module.exports = __webpack_public_path__ + "img/walterskirchen_filialkirche.944208aa.jpg";